import { render } from "./Courier.vue?vue&type=template&id=2359a0fa&scoped=true&ts=true"
import script from "./Courier.vue?vue&type=script&lang=ts"
export * from "./Courier.vue?vue&type=script&lang=ts"

import "./Courier.vue?vue&type=style&index=0&id=2359a0fa&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2359a0fa"]])

export default __exports__